import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const MapMarkerIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M12 0C10.5273 0 9.33333 1.194 9.33333 2.66667C9.33333 4.04133 10.7215 5.8622 11.4948 6.76953C11.7608 7.08153 12.2392 7.08153 12.5052 6.76953C13.2779 5.8622 14.6667 4.04133 14.6667 2.66667C14.6667 1.194 13.4727 0 12 0ZM12 1.71354C12.526 1.71354 12.9531 2.14067 12.9531 2.66667C12.9531 3.19267 12.526 3.61979 12 3.61979C11.474 3.61979 11.0469 3.19267 11.0469 2.66667C11.0469 2.14067 11.474 1.71354 12 1.71354ZM5.98177 2.04297C5.8266 2.04755 5.67238 2.07969 5.52604 2.13802L2.83854 3.21354C2.33254 3.41621 2 3.90649 2 4.45182V12.3477C2 13.291 2.95213 13.9359 3.82812 13.5859L6.02083 12.7096L9.55859 13.888C9.85793 13.988 10.1826 13.9786 10.4753 13.862L13.1615 12.7865C13.6675 12.5845 14 12.0935 14 11.5482V7.05729C13.5387 7.64396 13.131 8.08175 12.9583 8.26042C12.4343 8.80308 11.5644 8.80308 11.0404 8.26042C10.8677 8.08175 10.46 7.64396 9.9987 7.05729V11.694C9.9987 12.148 9.55503 12.4688 9.1237 12.3268L6.45703 11.4492C6.18436 11.3586 6 11.1024 6 10.8151V4.30339C6 3.85005 6.44303 3.52991 6.8737 3.67057L8.28516 4.13151C8.11049 3.64084 8 3.14533 8 2.66667C8 2.65467 8.0026 2.64351 8.0026 2.63151L6.44271 2.11198C6.29304 2.06198 6.13694 2.03839 5.98177 2.04297Z"
      fill={props.sx?.color || '#9C9FA5'}
    />
  </SvgIcon>
);

MapMarkerIcon.propTypes = {
  sx: PropTypes.object,
};

export default MapMarkerIcon;
